import React from "react"
import Sidebar from "./Sidebar"
import MainContent from "./MainContent"
import RequestLink from "./RequestLink"

/**
 * Content Page Component
 * Displays the split layout for article/category pages
 */
const ContentPage = ({
  rootCategoriesData,
  onArticleSelect,
  onCategorySelect,
  expandedCategories,
  currentPath,
  isLoading,
  error,
  selectedContent,
  contentType,
  onFeedback,
  navigateTo,
}) => {
  return (
    <div className="relative flex flex-col lg:flex-row w-full pb-[240px]">
      {/* Left sidebar - categories and articles navigation */}
      <Sidebar
        rootCategoriesData={rootCategoriesData}
        onArticleSelect={onArticleSelect}
        onCategorySelect={onCategorySelect}
        expandedCategories={expandedCategories}
        currentPath={currentPath}
      />

      {/* Right content area */}
      <MainContent
        isLoading={isLoading}
        error={error}
        selectedContent={selectedContent}
        contentType={contentType}
        onFeedback={onFeedback}
        navigateTo={navigateTo}
      />

      {/* Request form link at bottom of page */}
      <div className="absolute bottom-[60px] md:bottom-[112px] left-1/2 translate-x-[-50%] w-full">
        <RequestLink />
      </div>
    </div>
  )
}

export default ContentPage
